import type { ProductDefaultFieldOption } from './ProductTransform'

export type ProductSelectOption = {
  label: string
  value: string | number
}

type ProductSelectFallbackValue = {
  value?: string | number | null
}

function hasValue(value: unknown): value is string | number {
  return value !== undefined && value !== null
}

function uniqueOptions(options: ProductSelectOption[]) {
  const seenValues = new Set<string | number>()

  return options.filter((option) => {
    if (seenValues.has(option.value)) return false

    seenValues.add(option.value)
    return true
  })
}

export function getConfiguredProductSelectOptions(
  options?: ProductDefaultFieldOption[]
) {
  return uniqueOptions(
    (options ?? [])
      .filter((option) => hasValue(option.value))
      .sort(
        (left, right) =>
          (left.display_order ?? Number.MAX_SAFE_INTEGER) -
          (right.display_order ?? Number.MAX_SAFE_INTEGER)
      )
      .map((option) => ({
        label: option.label || String(option.value),
        value: option.value,
      }))
  )
}

export function getProductSelectOptions(
  configuredOptions: ProductDefaultFieldOption[] | undefined,
  fallbackValues: ProductSelectFallbackValue[]
) {
  const options = getConfiguredProductSelectOptions(configuredOptions)

  if (options.length) {
    return {
      hasConfiguredOptions: true,
      options,
    }
  }

  return {
    hasConfiguredOptions: false,
    options: uniqueOptions(
      fallbackValues
        .filter((option) => hasValue(option.value))
        .map((option) => ({
          label: String(option.value),
          value: option.value,
        }))
    ),
  }
}
